import * as types from './constants';

// Get Network Order Detail
export const getNetworkOrderDetailRequest = data => (
  { type: types.GET_NETWORK_ORDER_DETAIL_REQUEST, payload: data }
);

export const getNetworkOrderDetailDone = data => (
  { type: types.GET_NETWORK_ORDER_DETAIL_DONE, payload: data }
);

export const getNetworkOrderDetailFailed = errors => (
  { type: types.GET_NETWORK_ORDER_DETAIL_FAILED, payload: errors }
);

export const getNetworkOrderDetailReset = () => (
  { type: types.GET_NETWORK_ORDER_DETAIL_RESET }
);

// Cancel Network Order
export const cancelNetworkOrderRequest = data => (
  { type: types.CANCEL_NETWORK_ORDER_REQUEST, payload: data }
);

export const cancelNetworkOrderDone = data => (
  { type: types.CANCEL_NETWORK_ORDER_DONE, payload: data }
);

export const cancelNetworkOrderFailed = errors => (
  { type: types.CANCEL_NETWORK_ORDER_FAILED, payload: errors }
);
